import { Button, ButtonVariant } from '@Core/Components'
import { Grid } from '@Core/Components/Grid/Grid'
import { IconButton } from '@Core/Components/IconButton/IconButton'
import { Input } from '@Core/Components/Input/Input'
import { InputAutoComplete } from '@Core/Components/InputAutoComplete/InputAutoComplete'
import { TextArea } from '@Core/Components/TextArea/TextArea'
import { RightContent } from '@Entry/Common/Header/Header.styles'
import DeleteIcon from '@assets/delete.png'
import { Card, CardContent, InputAdornment } from '@material-ui/core'
import { BsCalculator } from 'react-icons/bs'
import { DatePicker } from '../DatePicker/DatePicker'
import { Status } from './EntryForm.styles'
import { EntryFormProps } from './EntryForm.types'

export const EntryForm = ({
    state,
    errors,
    handleChange,
    control,
    handleAutoCompleteChange,
    products = [],
    register,
    handleDateChange,
    handleCalculate,
    onRemove,
    isFailed,
    isCreated,
    suppliers = [],
}: EntryFormProps) => {
    return (
        <Card>
            <Status error={isFailed} success={isCreated}>
                <div className="success">
                    <span>Criado</span>
                </div>
                <Grid container flex flexEnd>
                    <RightContent
                        style={{
                            padding: '0.5rem 1rem',
                            paddingBottom: '0',
                        }}
                    >
                        <IconButton
                            size="small"
                            alignItems="center"
                            onClick={() => onRemove(state.id)}
                        >
                            <img src={DeleteIcon} alt="Remover" />
                        </IconButton>
                    </RightContent>
                </Grid>
                <CardContent>
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            {suppliers.length > 0 && (
                                <InputAutoComplete
                                    label="Fornecedor"
                                    errors={errors}
                                    name={`supplier-${state.id}`}
                                    onChange={handleAutoCompleteChange(
                                        `supplier-${state.id}`
                                    )}
                                    results={suppliers}
                                    inputProps={{
                                        disabled: Boolean(isCreated),
                                        name: `supplier-${state.id}`,
                                        register: register(
                                            `supplier-${state.id}`
                                        ),
                                        useUnform: false,
                                    }}
                                />
                            )}
                        </Grid>
                        <Grid item xs={8} lg={8}>
                            {products.length > 0 && (
                                <InputAutoComplete
                                    label="Produto"
                                    errors={errors}
                                    value={state?.[`product-${state.id}`]}
                                    name={`product-${state.id}`}
                                    onChange={handleAutoCompleteChange(
                                        `product-${state.id}`
                                    )}
                                    results={products}
                                    inputProps={{
                                        disabled: Boolean(isCreated),
                                        name: `product-${state.id}`,
                                        register: register(
                                            `product-${state.id}`
                                        ),
                                        useUnform: false,
                                    }}
                                />
                            )}
                        </Grid>
                        {state &&
                            state?.[`product-${state.id}`] &&
                            state?.[`unitCost-${state.id}`] !== undefined && (
                                <Grid item xs={4} lg={4}>
                                    <Input
                                        errors={errors}
                                        register={register(
                                            `unitCost-${state.id}`
                                        )}
                                        useUnform={false}
                                        control={control}
                                        type="number"
                                        disabled={Boolean(isCreated)}
                                        name={`unitCost-${state.id}`}
                                        label="Custo Unitário"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    R$
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                            )}
                        <Grid item xs={4} lg={4}>
                            <Input
                                register={register(`quantity-${state.id}`)}
                                useUnform={false}
                                errors={errors}
                                control={control}
                                disabled={Boolean(isCreated)}
                                name={`quantity-${state.id}`}
                                label="Quantidade"
                            />
                        </Grid>
                        <Grid item xs={4} lg={4}>
                            <Input
                                register={register(
                                    `totalPurchaseValue-${state.id}`
                                )}
                                useUnform={false}
                                control={control}
                                errors={errors}
                                disabled={Boolean(isCreated)}
                                name="totalPurchaseValue"
                                label="Valor Total"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            R$
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Button
                                                onClick={handleCalculate}
                                                type="button"
                                                title="Calcular quantidade x valor unitário"
                                                variant={ButtonVariant.tertiary}
                                            >
                                                <BsCalculator />
                                            </Button>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={4} lg={4}>
                            <DatePicker
                                inputProps={{
                                    errors: errors,
                                    disabled: Boolean(isCreated),
                                    control: control,
                                    register: register(
                                        `created_at-${state.id}`
                                    ),
                                    useUnform: false,
                                    label: 'Data da Entrada',
                                }}
                                onChange={handleDateChange(
                                    `created_at-${state.id}`
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} lg={12}>
                            <TextArea
                                control={control}
                                register={register(`observation-${state.id}`)}
                                useUnform={false}
                                name={`observation-${state.id}`}
                                label="Observações"
                                rows={5}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Status>
        </Card>
    )
}
